import React from "react";
import PropTypes from "prop-types";

import Typography from "../Typography/Typography";

import { containsUrl } from "../../utils/url/url";

const TooltipMessage = ({ style, message, onClick }) => {
  if (containsUrl(message)) {
    let parts = message.split(/(https?:\/\/[^\s]+)/g);

    for (let i = 0; i < parts.length; i++) {
      if (parts[i].indexOf("http") > -1) {
        const url = parts[i];
        parts[i] = (
          <a
            key={i}
            target="_blank"
            rel="noopener noreferrer"
            href={url}
            dangerouslySetInnerHTML={{ __html: url }}
          />
        );
      }
    }

    return (
      <Typography
        style={style}
        variant={Typography.variant.body4}
        onClick={onClick}
      >
        {parts}
      </Typography>
    );
  }

  return (
    <Typography
      style={style}
      variant={Typography.variant.body4}
      dangerouslySetInnerHTML={{ __html: message }}
      onClick={onClick}
    />
  );
};

TooltipMessage.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};

export default TooltipMessage;
